import type { SVGProps } from 'react';
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M12.6218 7.25754L19.7424 14.3782C20.0859 14.7216 20.0859 15.2784 19.7424 15.6218L18.9119 16.4523C18.5691 16.7951 18.0134 16.7958 17.6698 16.4537L12 10.8105L6.33019 16.4538C5.98655 16.7958 5.43091 16.7951 5.08808 16.4523L4.25757 15.6218C3.91414 15.2784 3.91414 14.7216 4.25757 14.3782L11.3782 7.25757C11.7216 6.91415 12.2784 6.91415 12.6218 7.25754Z" />
  </svg>
);
export default SvgChevronUp;
